import { useQuery, useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../../js/api/axios";
import { queryClient } from "../queryClient";

export const fetchLikedColors = async (colorCodes) => {
  const response = await axiosInstance.get(
    `/umbraco/api/savedColours/getLinkedColours?${colorCodes
      ?.map((colorCode) => `code=${colorCode}`)
      .join("&")}`
  );
  return response.data;
};

export const useLikedColors = (codes) => {
  return useQuery({
    queryKey: ["my-liked-colors-dialog", codes],
    queryFn: () => fetchLikedColors(codes),
  });
};

export const syncColors = async (colorCodes) => {
  const response = await axiosInstance.post(
    "/umbraco/api/savedColours/saveColourList",
    colorCodes
  );
  return response.data;
};

export const useLinkColors = () => {
  return useMutation({
    mutationFn: async ({ colorCodes }) => {
      await syncColors(colorCodes);
    },
    onSuccess: (_, { successHandler }) => {
      queryClient.invalidateQueries("my-saved-colors-dialog").then((data) => {
        if (successHandler) {
          successHandler(data);
        }
      });
    },
    onError: (_, { errorHandler }) => {
      if (errorHandler) {
        errorHandler();
      }
    },
  });
};
